module.exports = __webpack_public_path__ + "img/GD.8271b39f.png";